export default __webpack_public_path__ + "static/media/img_logo_hyundai.14482a77.svg";